<template>
  <v-layout row justify-center>
    <v-dialog
      v-model="dialogOpened"
      :overlay="false"
      persistent
      max-width="1440px"
    >
      <v-card class="image-uploader__content-container">
        <div>
          <div class="image-uploader__btn-container">
            <v-btn
              @click.native="onFocus"
              large
            >
              <v-icon
                right
                dark
              >attach_file
              </v-icon>
              Choose images
              <input
                type="file"
                :accept="accept"
                multiple
                ref="fileInput"
                @change="onFileChange"
                class="image-uploader__input"
                :value="value"
              >
            </v-btn>
          </div>

          <div class="image-uploader__preview-container">
            <div
              v-for="(image, i) in imagesPreviews"
              :key="`${image}-${i}`"
              class="image-uploader__image-preview"
            >
              <img
                :src="image.src"
                class="image-uploader__image-preview-img"
              />
              <span
                class="image-uploader__image-preview-delete"
                @click="removeImage(image.name, index)"
              >&#10006;</span>
            </div>
          </div>
          <div
            class="image-uploader__btn-container"
            v-if="imagesPreviews.length"
          >
            <v-btn
              large
              color="green lighten-4"
              class="image-uploader__btn-upload"
              @click="uploadImages"
            >Upload
            </v-btn>
          </div>
        </div>
        <v-btn
          fab
          color="deep-orange lighten-4"
          class="image-uploader__btn-close"
          @click="closeDialog"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import { mapActions } from 'vuex'
  import { remove } from 'ramda'

  export default {
    name: 'AImageUploaderModal',
    data () {
      return {
        dialogOpened: false,
        accept: 'image/*',
        imagesPreviews: [],
        files: new window.FormData(),
        value: ''
      }
    },
    methods: {
      ...mapActions({
        uploadMedia: 'media/uploadMedia'
      }),
      uploadImages () {
        this.uploadMedia(this.files)
      },
      onFocus () {
        this.$refs.fileInput.click()
      },
      onFileChange (e) {
        const files = e.target.files || e.dataTransfer.files
        this.getFormData(files)
      },
      getFormData (files) {
        [...files].forEach((file, index) => {
          /** In case image is not picked yet - add it to the imagesPreviews and files (FormData object) **/
          const imageName = file.name
          if (!this.files.has(imageName)) {
            const picReader = new window.FileReader()
            picReader.addEventListener('load', event => {
              this.imagesPreviews.push({
                name: imageName,
                src: event.target.result,
                alt: '',
                title: ''
              })
            })
            picReader.readAsDataURL(file)
            this.files.append(`${imageName}`, file, file.name)
          }
        })
      },
      removeImage (name, index) {
        this.files.delete(name)
        this.imagesPreviews = remove(index, 1, this.imagesPreviews)
      },
      closeDialog () {
        this.dialogOpened = false
        this.imagesPreviews = []
        this.files = new window.FormData()
      }
    },
    mounted () {
      this.$bus.$on('openImageUploaderModal', () => {
        this.dialogOpened = true
      })
    }
  }
</script>

<style lang="scss" scoped>
  .image-uploader {
    &__content-container {
      min-height: 100px;
      padding: 20px 0;
      position: relative;
    }

    &__input {
      display: none;
    }

    &__preview-container {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
    }

    &__image-preview {
      display: inline-block;
      width: 300px;
      height: 200px;
      position: relative;
      margin: 30px 30px 10px 10px;
      box-shadow: 0 1px 5px 1px #cacaca;
    }

    &__image-preview-img {
      width: 100%;
      height: 100%;
    }

    &__image-preview-delete {
      position: absolute;
      top: -20px;
      right: -20px;
      cursor: pointer;
      font-size: 18px;
    }

    &__btn-container {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &__btn-close {
      position: absolute;
      top: 0;
      right: 0;
    }

    &__btn-upload {
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/AImageUploaderModal/index.vue